import type {Reducer} from 'react';

// Modules
import storage from '@deezer/next/shared/utils/storage';

// Types
import type {MainAppAction, MainAppState, MyUser} from './types';
import {MainAppStateActionType} from './types';
import {onTokenUpdate} from '@deezer/next/contexts/main/effects';
import {
	LEGACY_SELECTED_ARTIST_KEY,
	STARMANIA_ACTIVE_ARTIST_STORAGE_KEY,
	STARMANIA_AUTH_TOKEN_STORAGE_KEY,
	STARMANIA_USER_STORAGE_KEY,
} from '@constants/storageKeys';

export const getDefaultState = (): MainAppState => {
	const authToken = storage.get(STARMANIA_AUTH_TOKEN_STORAGE_KEY, '');
	const user = storage.get<MyUser>(STARMANIA_USER_STORAGE_KEY) || undefined;
	const artistId =
		storage.get<number>(STARMANIA_ACTIVE_ARTIST_STORAGE_KEY) ||
		storage.get(LEGACY_SELECTED_ARTIST_KEY) ||
		undefined;

	onTokenUpdate(authToken);

	return {
		authToken,
		user,
		claims: [],
		isClaimsLoaded: false,
		profiles: [], // TODO REHYDRATE
		artistId,
	};
};

// Reducer
export const mainReducer: Reducer<MainAppState, MainAppAction> = (
	state = getDefaultState(),
	action,
): MainAppState => {
	switch (action.type) {
		case MainAppStateActionType.SET_TOKEN:
			return {
				...state,
				authToken: action.value,
			};
		case MainAppStateActionType.SET_USER:
			return {
				...state,
				user: action.user,
			};
		case MainAppStateActionType.SET_PROFILES:
			return {
				...state,
				profiles: action.profiles,
			};
		case MainAppStateActionType.SET_CLAIMS:
			return {
				...state,
				claims: action.claims,
				isClaimsLoaded: true,
			};
		case MainAppStateActionType.SET_ACTIVE_ARTIST:
			return {
				...state,
				artistId: action.artistId,
			};
		default:
			return state;
	}
};
